import { Map } from 'immutable';

import { sliceReducer, composeReducers } from '../../lib/reducers';
import * as constants from './constants';

import { createReducer as createFormWidgetReducer } from '../../components/Form/Widget';

import * as actions from './actions';

const initialState = Map({
  resourceId: null,
});

function baseReducer(state, action) {
  switch (action.type) {
    case actions.POST.REQUEST:
    case actions.UPDATE.REQUEST: {
      return state.setIn([action.payload.form, 'isLoading'], true);
    }

    case actions.POST.SUCCESS:
    case actions.UPDATE.SUCCESS: {
      return state.mergeIn(
        [action.payload.form],
        {
          isLoading: false,
          isEditable: false,
        },
      );
    }

    case actions.POST.FAILURE:
    case actions.UPDATE.FAILURE: {
      return state.mergeIn(
        [action.payload.form],
        {
          isLoading: false,
        },
      );
    }


    default: {
      return state;
    }
  }
}

export default composeReducers([
  sliceReducer(
    [constants.RESOURCE_FORM_MAIN],
    createFormWidgetReducer(constants.RESOURCE_FORM_MAIN),
  ),
  sliceReducer(
    [constants.RESOURCE_EXTERNAL_FORM],
    createFormWidgetReducer(constants.RESOURCE_EXTERNAL_FORM),
  ),
  sliceReducer(
    [constants.RESOURCE_EVENTS_FORM],
    createFormWidgetReducer(constants.RESOURCE_EVENTS_FORM),
  ),
  sliceReducer(
    [constants.RESOURCE_TASK_FORM],
    createFormWidgetReducer(constants.RESOURCE_TASK_FORM),
  ),
  sliceReducer(
    [constants.RESOURCE_PLACES_FORM],
    createFormWidgetReducer(constants.RESOURCE_PLACES_FORM),
  ),
  sliceReducer(
    [constants.RESOURCE_FILES_FORM],
    createFormWidgetReducer(constants.RESOURCE_FILES_FORM),
  ),
  baseReducer,
], initialState);
